export const PRIMARY_FONT = `'Noto Serif Display', serif;`;
export const SECONDARY_FONT = `'Tinos', serif;`;
export const FANTASY = PRIMARY_FONT;
export const CURSIVE = PRIMARY_FONT;

export const HEADING_FONT = `Butler, sans-serif;`;
export const HEADING_ALTERNATIVE = `'Poppins', serif;`;
export const BODY_FONT = `'Newsreader', serif;`;
